"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _CodeSplitEnvWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/CodeSplitEnvWrapper"));

var CalculatorCTAsContainer = function CalculatorCTAsContainer(props) {
  // TODO: Have to figure out how to properly get props through
  // TODO: https://product.hubteam.com/docs/frontend/changes/code-splitting.html
  return _react.default.createElement(_CodeSplitEnvWrapper.default, {
    authedComponentLoader: function authedComponentLoader() {
      return import(
      /* webpackChunkName: "authed-chunk" */
      "pricing-pages-unified-ui/components/calculator/CalculatorAuthedCTAs");
    },
    publicComponentLoader: function publicComponentLoader() {
      return import(
      /* webpackChunkName: "public-chunk" */
      "pricing-pages-unified-ui/components/public-only/CalculatorPublicCTAs");
    },
    authedComponentProps: (0, _extends2.default)({}, props),
    publicComponentProps: (0, _extends2.default)({}, props)
  });
};

var _default = CalculatorCTAsContainer;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/CalculatorCTAsContainer.js
// module id = 813
// module chunks = 5 6